const en = {
  mainMenu: {
    continueButton: 'Continue',
    startButton: 'Start',
    settingsButton: 'Settings',
    tutorialButton: 'Tutorial',
    resultButton: 'Statistics',
    saveButton: 'Save',
    backButton: 'Back',
    mainMenuTitle: 'Main menu',
    settingsMenuTitle: 'Settings menu',
    TutorialMenuTitle: 'Tutorial',
    resultMenuTitle: 'Statistics',
    labelCountOfWords: 'Count of words to win',
    labelRoundTime: 'Round time, seconds',
    labelLanguage: 'Language',
    tableLabelTeam: 'Team',
    tableLabelScore: 'Score',
    labelSounds: 'Sounds',
    essenceTitle: 'Essence',
    essenceContent:
      'Players are divided into groups. The number of players in each group does not have to be equal. The goal of the players is to explain the conceived word to teammates without using gestures and words of the same root',
    pointsTitle: 'Points',
    pointsContent:
      'Each guessed word gives the team 1 point. If the team did not manage to answer the last word - the word is not counted. The team gets 0 points',
    winnerTitle: 'Winner',
    winnerContent: 'The game lasts until one of the teams has the required number of points to win',
    hotkeysMenuTitle: 'Hotkeys',
    hotkeysMenuContent:
      '<span class="material-icons yellow">swap_vert</span> - during the game the navigation through the menu is responsible for the "confirmation" and "skipping" of words</br><span class="green">Space</span> и <span class="green">Enter</span> - in the menu are responsible for the "input", during the game are responsible for the "confirmation" of words.</br><span class="red">Esc</span> - return to the previous menu, in the game is responsible for the pause menu. The pause menu can be called by clicking on the command name.',
  },
  pauseMenu: {
    gamePause: 'Pause',
    gameResume: 'Resume',
    toMainMenu: 'Menu',
  },
  commandMenu: {
    allCommands: 'All commands',
    loadingTeams: 'Create team please',
    teamName: 'Team name',
    addTeamButton: 'Add team',
    backMenuButton: 'Get back',
    startGameButton: 'Start game',
    deleteTeamButton: `&#10006`,
  },
  game: {
    cardsSeletionContainerClassic: 'Classic',
    gameContainerTime: 'Time:',
    gameContainerPoints: 'Points:',
    gameContainerReady: 'Confirm',
    gameContainerSkip: 'Skip',
    gameContainertimeOut: 'Time out!',
    finishGameModalWin: 'Victory ',
    finishGameModalTeam: 'team:',
    finishGameModalBackToMenu: 'Main menu',
    roundStatisticsModalConfirmed: 'Confirmed:',
    roundStatisticsModalSkiped: 'Skiped:',
    roundStatisticsNextRound: 'Next round',
    correctWordButton: 'Right word',
    incorrectWordButton: 'Incorrect word',
    timeLabel: 'Time:',
    timeOutLabel: 'Time out!',
  },
};

export default en;
